import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { StoreLayout } from "@/components/StoreLayout";
import { api } from "@/lib/api";
import { useSiteContent } from "@/context/SiteContentContext";
import { CategoryTiles } from "@/pages/home/CategoryTiles";
import { BestsellersSection } from "@/pages/home/BestsellersSection";
import { OurPromiseSection } from "@/pages/home/OurPromiseSection";
import { CollectionsSection } from "@/pages/home/CollectionsSection";
import { TrustStripSection } from "@/pages/home/TrustStripSection";

const DEFAULT_PROMISES = [
  { title: "Certified & Hallmarked Jewellery" },
  { title: "Free Shipping & Insurance" },
  { title: "Hassle Free 15 Day Returns" },
  { title: "90% Buyback & 100% Exchange" },
];
const BUYBACK_PROMISE = { title: "90% Buyback & 100% Exchange" };

const COLLECTIONS = [
  { title: "Daily Essentials", image: "https://images.pexels.com/photos/7371946/pexels-photo-7371946.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940", dark: false, link: "/products?category=Bangles" },
  { title: "Minimal Elegance", image: "https://images.unsplash.com/photo-1589713680561-1d0b6945a582?crop=entropy&cs=srgb&fm=jpg&q=85", dark: false, link: "/products?category=Pendants" },
  { title: "Timeless Solitaire", image: "https://images.pexels.com/photos/19525067/pexels-photo-19525067.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940", dark: true, link: "/products?category=Rings" },
  { title: "Gift Her", image: "https://images.unsplash.com/photo-1513201099705-a9746e1e201f?crop=entropy&cs=srgb&fm=jpg&q=85", dark: false, link: "/products?category=Earrings" },
];

const DEFAULT_TRUST = [
  { label: "Finest Craftsmanship" },
  { label: "Ethical Sourcing" },
  { label: "Secure Payments" },
  { label: "Dedicated Support" },
];

export default function Home() {
  const navigate = useNavigate();
  const { categories, content: siteContent, loaded } = useSiteContent();
  const [featured, setFeatured] = useState([]);

  useEffect(() => {
    api.get("/products?featured=true").then(({ data }) => setFeatured(data)).catch(() => {});
  }, []);

  const c = siteContent || {};

  const promises = useMemo(() => {
    let list = c.trust_badges && c.trust_badges.length ? [...c.trust_badges] : [...DEFAULT_PROMISES];
    if (list.length < 4) list = [...list, BUYBACK_PROMISE];
    return list.slice(0, 4);
  }, [c.trust_badges]);

  const collections = useMemo(() => (
    c.collections && c.collections.length ? c.collections : COLLECTIONS
  ), [c.collections]);

  const trustStrip = useMemo(() => (
    c.trust_strip && c.trust_strip.length ? c.trust_strip : DEFAULT_TRUST
  ), [c.trust_strip]);

  return (
    <StoreLayout>
      <CategoryTiles categories={categories} loaded={loaded} onSelect={(cat) => navigate(`/products?category=${encodeURIComponent(cat.name)}`)} />

      <BestsellersSection
        title={c.featured_title || "Our Bestsellers"}
        products={featured} onViewAll={() => navigate("/products?featured=true")}
      />

      <OurPromiseSection promises={promises} />

      <CollectionsSection collections={collections} onSelect={(col) => navigate(col.link || "/products")} />

      <TrustStripSection trustStrip={trustStrip} />
    </StoreLayout>
  );
}
